export const tabIdsWithRequiredInputFields = new Map([
  ['details', ['summary', 'robot', 'description']],
  ['horstFXError', ['horstFXVersion', 'errorConfirmation']],
  ['error-information', ['errorTime', 'errorFrequency', 'errorReplication', 'internetConfirmation']],
  ['contactInformation', ['contactName', 'contactEmail', 'contactPhone']],
])
